import React from "react";
import { TableRow, TableCell, SkeletonItem } from "../po-numbers.styles";
import { COLUMN_WIDTHS } from "../consts";

const SkeletonRows = ({ rowCount = 5 }) => {
  return (
    <>
      {Array(rowCount)
        .fill()
        .map((_, index) => (
          <TableRow key={`skeleton-${index}`}>
            <TableCell width={COLUMN_WIDTHS.poNumber}>
              <SkeletonItem />
            </TableCell>
            <TableCell width={COLUMN_WIDTHS.venue}>
              <SkeletonItem />
            </TableCell>
            <TableCell width={COLUMN_WIDTHS.subvenue}>
              <SkeletonItem />
            </TableCell>
            <TableCell width={COLUMN_WIDTHS.role}>
              <SkeletonItem />
            </TableCell>
            <TableCell width={COLUMN_WIDTHS.startDate}>
              <SkeletonItem />
            </TableCell>
            <TableCell width={COLUMN_WIDTHS.endDate}>
              <SkeletonItem />
            </TableCell>
            <TableCell width={COLUMN_WIDTHS.status}>
              <SkeletonItem />
            </TableCell>
            <TableCell width={COLUMN_WIDTHS.actions}>
              <SkeletonItem />
            </TableCell>
          </TableRow>
        ))}
    </>
  );
};

export default SkeletonRows;
